import { gql } from 'apollo-angular';

const UPDATE_CONTRACT_PREFERENCES = gql`
  mutation UpdateRfp(
    $id: Long!
    $preferredContractDuration: Int
    $preferredContractEffectiveDate: Date
    $whenResponsesDue: Date
  ) {
    updateRfp(
      updateRfpRequest: {
        id: $id
        preferredContractDuration: $preferredContractDuration
        preferredContractEffectiveDate: $preferredContractEffectiveDate
        whenResponsesDue: $whenResponsesDue
      }
    ) {
      id
      preferredContractDuration
      preferredContractEffectiveDate
      offersDueDate
    }
  }
`;

export default UPDATE_CONTRACT_PREFERENCES;
